/// <amd-module name="Feed/Core/PackagingService" />
import { combineUrlPaths, Uri } from "VSS/Platform/Util/Url";

import { PackagingServiceInstanceId } from "Feed/Common/Constants/Constants";
import { ProjectReference } from "Feed/Common/Contracts/Feed";

export class PackagingService {
    public static readonly serviceInstanceId = PackagingServiceInstanceId;

    constructor(private rootUrl: string) {}

    public getUrl(project?: ProjectReference, path?: string) {
        const uri = new Uri(this.rootUrl, { absoluteUriRequired: true });

        if (project) {
            // Because some clients (e.g. mvn) can't handle encoded URIs, we substitute
            // the project ID (a GUID) in it's place when encoding would occur.
            const requiresEncoding = project.name !== encodeURIComponent(project.name);
            const projectPath = requiresEncoding ? encodeURIComponent(project.id) : project.name;
            uri.path = combineUrlPaths(uri.path, projectPath);
        }

        if (path) {
            uri.path = combineUrlPaths(uri.path, path);
        }

        return uri.absoluteUri;
    }

    public getApiUrl(project?: ProjectReference, path?: string) {
        return this.getUrl(project, combineUrlPaths("_apis", path || ""));
    }
}

export class TfsService {
    constructor(private sessionTokenUri: Uri) {}

    public getSessionTokenUri(): string {
        return this.sessionTokenUri.absoluteUri;
    }
}
